/** Shared selected state for choices and selected values in editable forms. */
export const formSelectionSurface = {
  bg: 'bg.selected',
  borderColor: 'border.selected',
  color: 'fg',
};

export const formSelectionLabel = {
  textStyle: 'sm',
  fontWeight: '500',
};

export const formSelectionIconSize = 6;
